import React, {Component} from "react";
import { Link, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { global } from './../config.js';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';

import ClipLoader from "react-spinners/ClipLoader";

class Items extends Component {

    constructor(props) {
        super(props);
        this.state = {
            results: [],
            loading: true,
            error: false,
            show_modal_new: false,
            title: "",
            adding: false,
            newId: false
        };

        this.items = this.items.bind(this)
        this.handleCloseNew = this.handleCloseNew.bind(this)
        this.handleChangeTitle = this.handleChangeTitle.bind(this)
        this.add = this.add.bind(this)
    }

    componentDidMount(){
        this.items()
    }

    items() {
        
        const requestOptions = {
            method: 'GET',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items', requestOptions)
        .then(res => res.json().then(
            (result) => {

                if (res.status === 200 && !result.error) {
                    this.setState({
                        results: result,
                        loading: false
                    });
                } else {
                    if (result.error) {
                        this.setState({
                            error: result.error.message
                        });
                    } else {
                        this.setState({
                            error: "Произошла ошибка. Пожалуйста, попробуйте позже."
                        });
                    }
                }
                this.setState({
                    loading: false
                });
            }
        ))

    }

    add() {
        const { title } = this.state

        this.setState({
            adding: true,
            error: false
        })

        if (title === '') {
            this.setState({
                adding: true,
                error: "Не указано название"
            })
            return;
        }

        const requestOptions = {
            method: 'POST',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify({title})
        };

        fetch(global.endpoint_api + '/items', requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.setState({
                        results: this.state.results.unshift(result.id),
                        show_modal_new: false,
                        newId: result.id
                    });
                    this.items()
                } else if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                    });
                }
    
                this.setState({
                    loading: false,
                });
            },
            (error) => {}
        ))
    }

    handleCloseNew() {
        this.setState({
            show_modal_new: false
        })
    }

    handleChangeTitle(event) {
        this.setState({title: event.target.value});
    }

    render() {

        let { results, loading, show_modal_new } = this.state

        if (this.state.newId) {
            return (<Navigate to={"/items/" + this.state.newId}/>)
        }

        return (
            <>
            <Row className="mb-4">
                <Col>
                    <h1>Карточки объектов</h1>
                    {/*
                    <Link to="/editor">Editor</Link>
                    */}
                </Col>
            </Row>
            <Row className="mb-4">
                <Col>
                    <Button variant="dark" onClick={() => this.setState({show_modal_new: true})}>Создать новую</Button>

                    <Modal show={show_modal_new}  onHide={this.handleCloseNew} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Новая карточка</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Название</Form.Label>
                                    <Form.Control type="text" placeholder="Экспонат" onChange={this.handleChangeTitle} />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer className="justify-content-between">
                            <Button variant="light" onClick={this.handleCloseNew}>
                                Закрыть
                            </Button>
                            <Button variant="dark" onClick={this.add}>
                                Создать
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </Col>
            </Row>
            <Row>
                <Col md={9} lg={6}>
                    <ClipLoader
                        loading={loading}
                        size={30}
                    />
                    
                    {Object.keys(results).map(function(key) {
                        return (
                            <Link key={key} className="no-link" to={"/items/" + results[key].id}>
                                <div className={"card card-simple " + (results[key].isActive ? "" : "notActive")}>
                                    <div className="card-body">
                                        <div className="d-flex justify-content-start">
                                            <div className="me-3">
                                                <img className="cover-preview-main mt-1" src={results[key].photo != null ? results[key].photo : "/images/icons/no-image.svg"} alt="Фото" />
                                            </div>
                                            <div className="w-100">
                                                <div className="d-flex justify-content-between mb-1">
                                                    <div>
                                                        <p className="truncate-text small m-0">ID: {results[key].id}</p>
                                                    </div>
                                                    <div className="small">
                                                        {results[key].isActive ? <><Image src="/images/icons/eye.svg" width={14}/><span className="d-none d-md-inline"> опубликовано</span></> : <><Image src="/images/icons/eye-slash.svg" width={14}/><span className="d-none d-md-inline"> скрыто</span></>}
                                                    </div>
                                                </div>
                                                <h5 className="truncate-text-lines">{results[key].title}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        )
                    })}
                </Col>
            </Row>
            </>
        )

    }
}

export default Items;